import React,{useState, useEffect} from 'react';
import {useHistory,useLocation } from 'react-router-dom'
import {DivPageFacebook} from './TutorialsStyle';
import Popup from 'reactjs-popup';
import api from '../../services/apiFacebook';
import LoadScreenSmall from '../../components/loadScreenSmall/loadScreenSmall';
import Toastify from '../../components/Toastify/index';
import Loading from '../../components/Loading/Loading';
function Tutorials() {
    const [pageFacebookData, setPageFacebookData] = useState([]);
    const [instagramList, setInstagramList] = useState([]);
    const [popupInstagramProfile, setPopupInstagramProfile ] = useState(false)
    const [smallScreen, setSmallScreen ] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const token = localStorage.getItem('acess_token');
    const config = require('../../assets/svgs/config.svg').default;
    const perfil = require('../../assets/svgs/perfil.svg').default;

    function loadDataPages(array){
        if(array?.data?.length > 0)
        return array.data.map(item=>{
            localStorage.setItem(item.id,item.access_token);
            return<DivPageFacebook key={item.id} onClick={()=>getInstagramRegistredId(item.id,item.access_token)}>
                <img src={item.cover.source}/>
                <span>{item.name}</span>
            </DivPageFacebook>
        })
    }
    function loadInstagramProfile(array){
        console.log(array);
        if(array?.length > 0)
        return array.map(item=>{
            return<DivPageFacebook key={item.id} >
                <img src={item.profile_pic}/>
                <span>{item.username}</span>
            </DivPageFacebook>
        })
    }

    async function loadPagesFacebook(){
        try {
            const data = await api.get('me?fields=accounts{bio,name,cover,access_token}&access_token=' + token);
            setPageFacebookData(data.data.accounts);
        } catch (error) {
            console.log(error)
            Toastify.error('Erro ao carregar dados do facebook faça o login novamente');
            history.push('/');
            window.location.reload();

        }


    }
    async function verifyStatusBusiness(instagram_id, token_acess_facebookPage){
        try {
            const data = await api.get(`${instagram_id}?fields=ig_id&access_token=${token_acess_facebookPage}`);
        } catch (error) {
            Toastify.warning('Perfil não configurado como business');
            console.log('Perfil não configurado como business');
            return
        }
    }
    async function getInstagramRegistredId(pageFacebookId,accessTokenPage){
        setSmallScreen(true);
        const data = await api.get(`${pageFacebookId}?fields=instagram_accounts,instagram_business_account&access_token=${accessTokenPage}`);
        debugger
        const arraysInstagrans = []
        if(data.status === 200){
            let statusBusiness = false;
            if(data?.data?.instagram_business_account)
                statusBusiness = true;
            if(data?.data?.instagram_accounts?.data?.length > 0 ){
                for (let index = 0; index < data.data.instagram_accounts.data.length; index++) {
                    const element = data.data.instagram_accounts.data[index];
                    const instagram = await loadInstagramRegistredInfo(element.id,accessTokenPage,statusBusiness);
                    // const verifyBusiness = await verifyStatusBusiness(element.id,accessTokenPage);
                    if (instagram !== 400)
                    arraysInstagrans.push(instagram);
                }
                console.log(arraysInstagrans);
                setInstagramList(arraysInstagrans)
            }
            setPopupInstagramProfile(true);
            setSmallScreen(false)
        }

    }
    async function loadInstagramRegistredInfo(instagramId,accessTokenPage,statusBusiness){
        const data = await api.get(`${instagramId}?fields=username,profile_pic&access_token=${accessTokenPage}`);
        if(data.status === 200){
            if(statusBusiness)
                Toastify.info('Conta Business');
            else
                Toastify.info('Conta nao configurada como business');
            return data.data
        }
        else{
            console.log('não carregou instagram');
            return 400
        }
    }

    useEffect(() => {
        loadPagesFacebook()

    }, [])
    return <Loading />
  return <div>
      <h1>Tutoriais</h1>
      <div>
        <h5>Como configurar a conta do instagram para uma conta business</h5>
        <ol type='1'>
            <li>Em configurações <img src={config} /> , encontre Conta <img src={perfil} /> e toque em <strong>Mudar para conta profissional</strong>.</li>
            <li>2</li>
            <li></li>
        </ol>
      </div>
      <div style={{display:'flex'}}>
          {
              loadDataPages(pageFacebookData)
          }
      </div>
      <Popup open={popupInstagramProfile} onClose={()=>setPopupInstagramProfile(false)}>
          <div>
            {loadInstagramProfile(instagramList)}
          </div>
      </Popup>
      {
            smallScreen ? <LoadScreenSmall open={smallScreen} close={setSmallScreen} /> : ''
        }
  </div> ;
}

export default Tutorials;
